import CardSideGroupSettings from './CardSideGroupSettings';

export default CardSideGroupSettings;
